module.exports = __webpack_public_path__ + "img/lvyou.e65be004.jpg";